// import "../../../src/assets/js/lightslider";

import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
import {
  getPlanSummaryById,
  setStateParams,
} from "../Redux/Actions/webAppActions";
import { connect } from "react-redux";
import history from "../Utils/History";

class RedirComp extends Component {
  async componentDidMount() {
    const params = this.props.match.params.planId.split("|");
    let id = params[0];
    let county = params[1];
    let state = params[2];
    let zip = params[3];
    // console.log(id, county, state)
    // console.log(county.split(" ").join("%20"))
    await this.props.setStateParams("state", state);
    await this.props.setStateParams("county", county);
    // let countyToSend = county.split(" ").join("%20");
    // console.log(countyToSend)
    let response = await this.props.getPlanSummaryById(id, zip, county);
    if (response && response.message === "SUCCESS") {
      history.push("/e-Enroll/select-plan");
    } else {
      this.props.history.push("/e-Enroll/login");
    }
  }

  render() {
    return <React.Fragment></React.Fragment>;
  }
}

const mapDispatchToProps = {
  getPlanSummaryById,
  setStateParams,
};

export default connect(null, mapDispatchToProps)(RedirComp);
